import { render, staticRenderFns } from "./CaseMagList.vue?vue&type=template&id=6fa70608&scoped=true&"
import script from "./CaseMagList.vue?vue&type=script&lang=js&"
export * from "./CaseMagList.vue?vue&type=script&lang=js&"
import style0 from "./CaseMagList.vue?vue&type=style&index=0&id=6fa70608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa70608",
  null
  
)

export default component.exports